var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEyeicn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "eyeicn",
    transform: "translate(-5410 636)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10841",
    "data-name": "Rectangle 10841",
    width: 42,
    height: 42,
    transform: "translate(5410 -636)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "noun-eye-5125609",
    d: "M131.005,134.871a21.67,21.67,0,0,0-18.858,10.949h0a1.1,1.1,0,0,0,0,1.087A21.669,21.669,0,0,0,131,157.87h0a21.669,21.669,0,0,0,18.855-10.956,1.1,1.1,0,0,0,0-1.087,21.672,21.672,0,0,0-18.855-10.956h0Zm0,2.219a19.425,19.425,0,0,1,16.587,9.281,19.462,19.462,0,0,1-33.176-.006A19.427,19.427,0,0,1,131,137.09Zm0,2.555a6.726,6.726,0,1,0,6.776,6.726A6.768,6.768,0,0,0,131,139.644Zm0,2.219a4.507,4.507,0,1,1-4.54,4.507A4.507,4.507,0,0,1,131,141.863Z",
    transform: "translate(5299.692 -761.52)",
    fill: "#313b5c",
    fillRule: "evenodd"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeicn);
export default __webpack_public_path__ + "static/media/eyeicn.8ff9a1d2bea945011b72c75fa30d3b64.svg";
export { ForwardRef as ReactComponent };